let request_as_promised = require("request-promise");
import router from "@/router";
import i18n from "../../i18n";
import axios from "axios";

export default {
  state: {
    qnaStatus: null,
    qnaKeyword: "",
    wrongAnswerCount: 0,
    court: "",
    isThinking: false,
    requestQna: true,
  },
  getters: {
    getQnaStatus: (state) => state.qnaStatus,
    getQnaKeyword: (state) => state.qnaKeyword,
    getWrongAnsCount: (state) => state.wrongAnswerCount,
    getCourt: (state) => state.court,
    getIsThinking: (state) => state.isThinking,
    getRequestQna: (state) => state.requestQna,
  },
  mutations: {
    setQnaStatus(state, status) {
      state.qnaStatus = status;
    },
    setQnaKeyword(state, keyword) {
      state.qnaKeyword = keyword;
    },
    setWrongAnswerCount(state, count) {
      state.wrongAnswerCount = count;
    },
    setCourt(state, court) {
      state.court = court;
    },
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setRequestQna(state, status) {
      state.requestQna = status;
    },
  },
  actions: {
    requestQnA({ getters, dispatch, commit }, transcript) {
      commit("setIsThinking", true);
      commit("setTextBubbleText", i18n.t("isThinking"));
      if (getters.isThinking) {
        commit("setSpeechTranscript", transcript);
        commit("setTextBubbleText", transcript);
      }

      console.log("Kiosk Profile: ", getters.getKioskProfile.data());

      let data = JSON.stringify({
        question: transcript,
        lang: "english",
        type: getters.getKioskProfile.data().locationCode,
        client: "nmcourts"
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios.request(config).then((response) => {
        console.log("Response: ", response.data);
        dispatch("generateAnswer", response.data);
      });
    },
    generateAnswer({ dispatch, commit, getters }, result) {
      commit("setIsThinking", false);
      commit("setQnaStatus", false);
      const metadata = result.answer.intent.toString();
      const ansObj = result.answer;
      console.log("Form keyword : ", metadata);
      commit("setDefaultBubbleText", false);
      commit("closeOptionsViewer");
      switch (metadata) {
        // Followup
        case "0":
          console.log("Follow up question: ", getters.getKioskProfile.data());
          var followup = null;
          dispatch("avatarSpeak", ansObj.response);
          if (getters.getKioskProfile.data().locationCode === "D1") {
            followup = i18n.t("santafequestions").split(",");
            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("optionViewerHeader"),
              dialogData: followup,
            });
          } else if (getters.getKioskProfile.data().locationCode === "D5") {
            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("optionViewerHeader"),
              dialogData: followup,
            });
          } else {
            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("optionViewerHeader"),
              dialogData: followup,
            });
          }
          break;
        // Navigate
        case "1":
          console.log("At navigate: ", ansObj);
          dispatch("avatarSpeak", ansObj.response);
          if (ansObj.metadata.path === "/todayshearing") {
            commit("setPageHeader", "Today's Hearing");
            router.push(ansObj.metadata.path);
          }
          break;
        // SearchByLinkId
        case "2":
          router.push("/faqs");
          commit("setQnaKeyword", ansObj.metadata.linkid);
          dispatch("avatarSpeak", ansObj.response);
          break;
        //ShowMap
        case "3":
          console.log("At showmap: ", ansObj, i18n.t("maps"));
          var mapObj = i18n
            .t("maps")
            .filter((map) => map.displayPosition === ansObj.metadata.mappath);
          console.log("Map Found: ", mapObj);
          dispatch("openImageViewer", {
            name: mapObj[0].mapName,
            url: mapObj[0].mapImage,
          });
          dispatch("avatarSpeak", mapObj[0].speech);
          break;
        //Speak
        case "4":
          dispatch("avatarSpeak", ansObj.response);
          break;
        //Fallback
        case "5":
          dispatch("avatarSpeak", ansObj.response);
          break;
        //ShowForm
        case "6":
          var formObj = i18n
            .t("forms")
            .filter((form) => form.formNumber === ansObj.metadata.formname);
          console.log("Form found: ", formObj);
          dispatch("openPdfViewer", {
            url: formObj[0].formPdf,
            name: formObj[0].formName,
            emailLink: formObj[0].pdfUrl,
            type: "Form",
          });
          dispatch("avatarSpeak", ansObj.response);
          break;
        //open URL
        case "7":
          break;
        case "navigate":
          var menuName = ansObj.metadata.find(
            ({ name }) => name === "navigateto"
          ).value;
          router.addRoute({
            path: menuName.toLowerCase(),
            component: () => import("@/views/" + menuName),
          });
          if (router.currentRoute.path !== menuName) {
            router.push(menuName).then(() => {
              commit("setQnaKeyword", "");
              dispatch("avatarSpeak", ansObj.answer);
              let page = i18n
                .t("homepages")
                .filter((page) => page.pageType[0].pathName === menuName);
              commit("setPageHeader", page[0].pageType[0].pageHeader);
            });
          } else {
            commit("setQnaKeyword", "");
            dispatch("avatarSpeak", ansObj.answer);
          }
          break;

        case "showmap":
          try {
            var mapPath;
            let mapName = ansObj.metadata.find(
              ({ name }) => name === "mappath"
            ).value;
            getters.getMaps.forEach((map) => {
              if (map.mapName.toLowerCase() === mapName) {
                mapPath = map;
              }
            });
            dispatch("openImageViewer", {
              name: mapPath.mapName,
              url: mapPath.mapImage,
            });
            if (getters.getCurrentLanguage === "en-US") {
              dispatch("avatarSpeak", ansObj.answer);
            }
          } catch (e) {
            console.log(e.message);
            getters.getMaps.forEach((map) => {
              if (
                map.mapName.toLowerCase() ===
                getters.getDefaultLocation.toLowerCase()
              ) {
                dispatch("openImageViewer", {
                  name: map.mapName,
                  url: map.mapImage,
                });
              }
            });

            //dispatch('avatarSpeak', 'Sorry, I\'m not sure how to answer this question. Please ask me a different question, or you can continue using the touch interface. Also, you can get more information at the Clerk’s Office located here.')
            if (getters.getCurrentLanguage === "en-US") {
              dispatch(
                "avatarSpeak",
                "Sorry, I'm not sure how to answer this question. Please ask me a different question, or you can continue using the touch interface. Also, you can get more information at the location circled in red."
              );
            } else {
              dispatch(
                "avatarSpeak",
                "Lo siento. No estoy seguro de cómo responder esta pregunta. Por favor, hazme una pregunta diferente, o puedes continuar usando la interfaz táctil. Además, puede obtener más información en la oficina del secretario ubicada aquí."
              );
            }
          }
          break;

        case "speak":
          dispatch("avatarSpeak", ansObj.answer);
          break;

        case "showform":
          try {
            var formName = ansObj.metadata.find(
              ({ name }) => name === "formname"
            ).value;
            i18n.t("forms").forEach((form) => {
              if (form.formName.toLowerCase() === formName) {
                dispatch("openPdfViewer", {
                  url: form.formPdf,
                  name: form.formName,
                  emailLink: form.pdfUrl,
                  type: "Form",
                });
                dispatch("avatarSpeak", ansObj.answer);
              }
            });
          } catch (e) {
            console.log(e.message);
            getters.getMaps.forEach((map) => {
              if (
                map.mapName.toLowerCase() ===
                getters.getDefaultLocation.toLowerCase()
              ) {
                dispatch("openImageViewer", {
                  name: map.mapName,
                  url: map.mapImage,
                });
              }
            });
            //dispatch('avatarSpeak', 'Sorry! I just started working here, I will soon know answers to all the court related questions. Pleas try asking different question or visit Clerk\'s office.');
            if (getters.getCurrentLanguage === "en-US") {
              dispatch(
                "avatarSpeak",
                "Sorry, I'm not sure how to answer this question. Please ask me a different question, or you can continue using the touch interface. Also, you can get more information at the location circled in red."
              );
            } else {
              dispatch(
                "avatarSpeak",
                "¡Lo siento! Acabo de empezar a trabajar aquí, pronto sabré respuestas a todas las preguntas relacionadas con la corte. Por favor, intente hacer otra pregunta o visitar la oficina de Clerk."
              );
            }
          }
          break;

        case "showfaqcategory":
          commit("setQnaKeyword", "");
          var faqKeyword = ansObj.metadata.find(
            ({ name }) => name === "keyword"
          ).value;

          router.addRoute({
            path: "/faqs",
            component: () => import("@/views/faqs"),
          });
          if (router.currentRoute.path !== "/faqs") {
            router.push("/faqs");
          }
          commit("setPageHeader", "Frequently Asked Questions");
          var count = i18n
            .t("faqCategory")
            .filter((cat) => cat.categoryName.toLowerCase() === faqKeyword);
          if (count.length === 0) {
            //dispatch('avatarSpeak', 'not found');
            commit("setQnaKeyword", faqKeyword);
          } else {
            commit("setSelectedFaqCat", {
              name: faqKeyword,
              type: "expansionPanel",
            });
          }
          dispatch("avatarSpeak", ansObj.answer);
          break;

        case "showformcategory":
          var formKeyword = ansObj.metadata.find(
            ({ name }) => name === "keyword"
          ).value;
          console.log("Form keyword : ", formKeyword);
          router.addRoute({
            path: "/forms",
            component: () => import("@/views/forms"),
          });
          if (router.currentRoute.path !== "/forms") {
            router.push("/forms");
          }
          commit("setPageHeader", "Forms");
          commit("setSelectedFormCat", {
            category: formKeyword,
            showTab: true,
          });
          dispatch("avatarSpeak", ansObj.answer);
          break;

        case "showformpackets":
          var packetInfo;
          packetInfo = getters.getFormPackets.filter(
            (pack) =>
              pack.packetName.toLowerCase() ===
              ansObj.metadata.find(({ name }) => name === "keyword").value
          );
          dispatch("openPdfViewer", {
            url: packetInfo[0].packetFiles,
            name: packetInfo[0].packetName,
            desc: packetInfo[0].packetDesc,
            emailLink: packetInfo[0].packetLink,
            type: "Packet",
          });
          dispatch("avatarSpeak", ansObj.answer);
          break;

        case "showimage":
          dispatch("avatarSpeak", ansObj.answer);
          break;

        case "showhours":
          //dispatch('openCourtTimingViewer', {})
          dispatch("avatarSpeak", ansObj.answer);

          break;

        case "session":
          var action = ansObj.metadata.find(
            ({ name }) => name === "action"
          ).value;
          if (action === "still there") {
            dispatch("kioskStillThere");
          } else {
            dispatch("resetKiosk");
          }
          break;

        case "followup":
          var prompts = ansObj.context.prompts;
          var followUp = [];
          dispatch("avatarSpeak", ansObj.answer);
          prompts.forEach((item) => followUp.push(item.displayText));
          dispatch("openOptionsViewer", {
            dialogHeader:
              "Tap on the below, or click on the microphone to ask another question",
            dialogData: followUp,
          });
          break;
        default:
          getters.getMaps.forEach((map) => {
            if (
              map.mapName.toLowerCase() ===
              getters.getDefaultLocation.toLowerCase()
            ) {
              dispatch("openImageViewer", {
                name: map.mapName,
                url: map.mapImage,
              });
            }
          });
          //dispatch('avatarSpeak', 'Sorry I’m still learning. Please ask me a different question or, get information about this topic at the Clerk’s Office located here.')
          if (getters.getCurrentLanguage === "en-US") {
            dispatch(
              "avatarSpeak",
              "Sorry, I'm not sure how to answer this question. Please ask me a different question, or you can continue using the touch interface. Also, you can get more information at the location circled in red."
            );
          } else {
            dispatch(
              "avatarSpeak",
              "¡Lo siento! Acabo de empezar a trabajar aquí, pronto sabré respuestas a todas las preguntas relacionadas con la corte. Por favor, intente hacer otra pregunta o visitar la oficina de Clerk."
            );
          }
          break;
      }
      // ToDo - Have to complete the intent based answers.
    },
  },
};
